/**
 * ヘッダー全体にクラス名「js-gnav」
 * ヘッダーメニューにクラス名「js-gnav-navbar」
 * ハンバーガーメニューにクラス名「js-gnav-toggle」
 * グローバルメニューにクラス名「js-gnav-menu」
 */

jQuery(function ($) {
	// PC時のナビゲーションの動き
	// ===========================
	// var $win = $(window),
	//     $cloneNav = $('.js-gnav').clone().addClass('js-gnav-clone').appendTo('body'),
	//     showClass = 'is-show';

	// $win.on('load scroll', function() {
	//   var value = $(this).scrollTop();
	// 	if (window.matchMedia('(min-width: 769px)').matches) {
	// 		if ( value > 700 ) {
	// 			$cloneNav.addClass(showClass);
	// 		} else {
	// 			$cloneNav.removeClass(showClass);
	// 		}
	// 	} else {
	// 		if ( value > 280 ) {
	// 			$cloneNav.addClass(showClass);
	// 		} else {
	// 			$cloneNav.removeClass(showClass);
	// 		}
	// 	}
	// });
});

// スマホメニューの切り替え
// ===========================
var gnavWrapperClass = $('.js-gnav'); // ナビゲーション全体を囲んでいるクラス名
var gnavToggleClass = $('.js-gnav-toggle'); // トグルメニューのクラス名
var gnavNavClass = $('.js-gnav-nav'); // ナビバーを囲んでいるクラス名
var activeClass = 'is-active'; // アクティブ時のクラス名

function SPmenuOpen() {
	gnavWrapperClass.toggleClass(activeClass);

	if ($(gnavWrapperClass).hasClass(activeClass)) {
		gnavToggleClass.addClass(activeClass);
		gnavNavClass.addClass(activeClass);
	} else {
		gnavToggleClass.removeClass(activeClass);
		gnavNavClass.removeClass(activeClass);
	}
}

gnavToggleClass.on('click', function () {
	SPmenuOpen();
});

$(document).on('click', function (e) {
	if (!$(e.target).closest('.js-gnav-navbar').length && $(gnavWrapperClass).hasClass(activeClass)) {
		SPmenuOpen();
	}
});

// ドロップダウンメニュー
// ===========================
var gnavMenuClass = $('.js-gnav-menu'); // メニューのクラス
var gnavSubMenuClass = '.sub-menu'; // サブメニューのクラス
var gnavHasSubmenuClass = '.menu-item-has-children'; // サブメニューを持っている親クラス

if (window.matchMedia('(min-width: 769px)').matches) {

	gnavMenuClass.find(gnavHasSubmenuClass).mouseenter(function () {

		$(this).addClass(activeClass);
		return false;

	}).mouseleave(function () {

		$(this).removeClass(activeClass);
		return false;

	});

} else {

	gnavMenuClass.find(gnavHasSubmenuClass).on('click', function () {
		$(this).toggleClass(activeClass);
	});

	$(gnavHasSubmenuClass).find(gnavSubMenuClass).on('click', function (e) {
		e.stopPropagation();
	});

}

// クリックイベントのリスナーを追加
document.querySelectorAll('.l-header-nav .rightbox__link a, .l-header-nav .rightbox__nav a').forEach(function (link) {
	link.addEventListener('click', function (event) {
		// リンクの href 属性からターゲットの要素を取得
		var targetId = link.getAttribute('href').substring(1); // href 属性から "#" を削除
		var targetElement = document.getElementById(targetId);

		// スクロールを行う
		if (targetElement) {
			window.scrollTo({
				top: targetElement.offsetTop, // ターゲット要素の位置までスクロール
				behavior: 'smooth', // スムーズなスクロールを有効にする
			});
		}

		// ターゲット要素を取得
		var gnavNav = document.querySelector('.l-header-nav.js-gnav-nav.js-gnav-nav--fix.is-active');
		var gnavToggle = document.querySelector('.js-gnav-toggle.is-active');
		var masthead = document.querySelector('#masthead.l-header.js-gnav.is-active');

		// クリックした要素からis-activeクラスを削除
		if (gnavNav) {
			gnavNav.classList.remove('is-active');
		}

		if (gnavToggle) {
			gnavToggle.classList.remove('is-active');
		}

		if (masthead) {
			masthead.classList.remove('is-active');
		}
	});
});
